import { LandingPage } from "../../../components/landing-page";
import { solutionLandingPages } from "../../../lib/landing-pages";

type Props = {
  slug: string;
};

export default function SolutionLandingPage({ slug }: Props) {
  const page = solutionLandingPages.find((item) => item.slug === slug);

  if (!page) return null;

  return (
    <LandingPage
      page={page}
      relatedPages={solutionLandingPages.filter((item) => item.slug !== slug)}
    />
  );
}
